import { render, staticRenderFns } from "./DialogCreateTopic.vue?vue&type=template&id=3fc41382"
import script from "./DialogCreateTopic.vue?vue&type=script&lang=js"
export * from "./DialogCreateTopic.vue?vue&type=script&lang=js"
import style0 from "./DialogCreateTopic.vue?vue&type=style&index=0&id=3fc41382&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports